import { render, staticRenderFns } from "./add-controls.vue?vue&type=template&id=4a51e1d2"
import script from "./add-controls.vue?vue&type=script&lang=js"
export * from "./add-controls.vue?vue&type=script&lang=js"
import style0 from "./add-controls.vue?vue&type=style&index=0&id=4a51e1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports